import { camelCase } from 'lodash';

import type { WalletTypeEnum } from '@swf/generated/types/api/sports';

export const getWalletFieldName = (walletType: WalletTypeEnum, redeemable?: boolean) => {
  if (walletType === 'BONUS_CASH') {
    return redeemable ? 'bonusCash' : 'freeBet';
  }

  return camelCase(walletType);
};
